export default {"src":"/_next/static/media/warning-icon.4378390a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};